import { ValueType } from '@hg-akademie-ban/vamos-viva-type-utils';

import { type ModulFromThemaRouter, PlanungsFormat, type ThemaFromThemaRouter, type Veranstaltung } from '../dtos.js';
import { isTermingruppe } from './isTermingruppe.js';

export const isOnlineVeranstaltung = (veranstaltung: Pick<Veranstaltung, 'onlineTool'>): boolean =>
  veranstaltung.onlineTool !== null;

export const isOnlineThema = (thema?: Pick<ThemaFromThemaRouter, 'isOnline'>): boolean => Boolean(thema?.isOnline);

export const onlineAndOrPraesenz = {
  ONLINE: 'ONLINE',
  PRAESENZ: 'PRAESENZ',
  PRAESENZ_AND_ONLINE: 'PRAESENZ_AND_ONLINE',
} as const;

export type OnlineAndOrPraesenz = ValueType<typeof onlineAndOrPraesenz>;

export const isOnlineAndOrPraesenz = (
  isOnline: ThemaFromThemaRouter['isOnline'],
  planungsformat: PlanungsFormat,
  module: Pick<ModulFromThemaRouter, 'isOnline'>[],
): OnlineAndOrPraesenz => {
  if (isTermingruppe(planungsformat)) {
    const hasOnline = module.some((modul) => modul.isOnline);
    const hasPraesenz = module.some((modul) => !modul.isOnline);
    if (hasOnline && hasPraesenz) {
      return onlineAndOrPraesenz.PRAESENZ_AND_ONLINE;
    }
    if (hasPraesenz) {
      return onlineAndOrPraesenz.PRAESENZ;
    }
    return onlineAndOrPraesenz.ONLINE;
  }

  if (isOnline) {
    return onlineAndOrPraesenz.ONLINE;
  }

  return onlineAndOrPraesenz.PRAESENZ;
};

export const getPendantLabel = (thema: ThemaFromThemaRouter['pendantThemen'][number]) => {
  if (isOnlineAndOrPraesenz(thema.isOnline, thema.planungsformat, thema.module) === 'ONLINE') {
    return 'Online-Pendant';
  }
  return 'Präsenz-Pendant';
};
